<template>
  <div>
    <span class="chart-header">
      <h3>{{title}}</h3>
      <p>{{subtitle}}</p>
    </span>
    <line-chart :chart-data="datacollection" v-if="datacollection !== null"></line-chart>
  </div>
</template>

<script>
  import LineChart from './LineChart.js'

  export default {
    components: {
      LineChart
    },
    data () {
      return {
      }
    },
    props: {
      datacollection: Object,
      title: String,
      subtitle: String,
    }
  }
</script>

<style lang="scss" scoped>

.chart-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1em;
}

</style>